import { createContext, useContext } from 'react';
import { To } from 'react-router-dom';

import SamplePoint from 'types/models/samplePoint';

type WeatherStationContextType = {
  controllerName: SamplePoint['name'];
  settingsUrl: To;
};

export const WeatherStationContext = createContext<WeatherStationContextType>({
  controllerName: undefined,
  settingsUrl: ''
});

export const useIsWeatherSensor = () => !!useContext(WeatherStationContext).settingsUrl;